import React from 'react';
import { Field } from 'formik';

import styles from './cardFormStyles';

import CharacterLimit from 'buyside/components/presentation/CharacterLimit/CharacterLimit';
import InputField from 'buyside/components/presentation/Form/Field/InputField/inputField';

const {
  aumRangeNames,
  allocatorFirmTypes,
  cities
} = require('buyside/util/constantsFromRails.json');

// NOTE: make sure to update the appropriate schema in util/allocatorProfileShowPageValidationSchemata

const CardForm = ({ values: { allocatorProfile } }) => {
  const descriptionLength = allocatorProfile.bio && allocatorProfile.bio.length;
  const cityNames = cities.map(city => city.name);
  return (
    <div data-testid="allocator-profile-form">
      <div className={styles.cardFormMainArea}>
        <div className={styles.cardFormColumn}>
          <Field
            component={InputField}
            name="allocatorProfile.aumRange"
            type="select"
            label="AUM"
            options={aumRangeNames}
          />
          <Field
            component={InputField}
            name="allocatorProfile.employerType"
            type="select"
            label="Allocator Type"
            options={allocatorFirmTypes}
          />
        </div>
        <div className={styles.cardFormColumn}>
          <Field
            component={InputField}
            name="allocatorProfile.location"
            type="select"
            label="Location"
            options={cityNames}
          />
          <Field component={InputField} name="allocatorProfile.fundManager" label="Managed By" />
        </div>
      </div>
      <div className={styles.cardFormDescription}>
        <Field
          component={InputField}
          name="allocatorProfile.bio"
          type="textarea"
          label="Description"
        />
        <CharacterLimit textLength={descriptionLength} limit={1250} />
      </div>
    </div>
  );
};

export default CardForm;
